/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Firstname_Label1Inputs */

const en_onboarding_firstname_label1 = /** @type {(inputs: Onboarding_Firstname_Label1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`First name`)
};

const fr_onboarding_firstname_label1 = /** @type {(inputs: Onboarding_Firstname_Label1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prénom`)
};

/**
* | output |
* | --- |
* | "First name" |
*
* @param {Onboarding_Firstname_Label1Inputs} inputs
* @param {{ locale?: "en" | "fr" }} options
* @returns {LocalizedString}
*/
const onboarding_firstname_label1 = /** @type {((inputs?: Onboarding_Firstname_Label1Inputs, options?: { locale?: "en" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Firstname_Label1Inputs, { locale?: "en" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_onboarding_firstname_label1(inputs)
	return fr_onboarding_firstname_label1(inputs)
});
export { onboarding_firstname_label1 as "onboarding_firstName_label" }